var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5748 4C8.00009 4 4.29153 7.58172 4.29153 12C4.29153 16.4183 8.00009 20 12.5748 20C17.1496 20 20.8581 16.4183 20.8581 12C20.8581 7.58172 17.1496 4 12.5748 4ZM2.2207 12C2.2207 6.47715 6.85641 2 12.5748 2C18.2933 2 22.929 6.47715 22.929 12C22.929 17.5228 18.2933 22 12.5748 22C6.85641 22 2.2207 17.5228 2.2207 12ZM10.8073 8.29289C11.2116 7.90237 11.8672 7.90237 12.2716 8.29289L15.3778 11.2929C15.7822 11.6834 15.7822 12.3166 15.3778 12.7071L12.2716 15.7071C11.8672 16.0976 11.2116 16.0976 10.8073 15.7071C10.4029 15.3166 10.4029 14.6834 10.8073 14.2929L13.1814 12L10.8073 9.70711C10.4029 9.31658 10.4029 8.68342 10.8073 8.29289Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircle);
export default __webpack_public_path__ + "static/media/chevron-right-circle.e115c3326c0ca7558c25769b57a29f7b.svg";
export { ForwardRef as ReactComponent };